import React from 'react';
import styled from 'styled-components';
import { AlertTriangle, Info } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const BannerContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
  color: white;
  padding: 12px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 4px 12px rgba(220, 38, 38, 0.3);
  z-index: 1000;
  border-bottom: 2px solid #991b1b;
  animation: slideDown 0.3s ease-out;

  @keyframes slideDown {
    from {
      transform: translateY(-100%);
    }
    to {
      transform: translateY(0);
    }
  }
`;

const BannerContent = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
`;

const BannerText = styled.span`
  font-weight: 600;
  font-size: 15px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
`;

const BannerActions = styled.div`
  display: flex;
  gap: 12px;
`;

const ActionButton = styled.button`
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: white;
  padding: 8px 16px;
  border-radius: 6px;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.3);
    border-color: rgba(255, 255, 255, 0.5);
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
`;

const RedBanner = ({ unpaidOrdersCount, onMoreInfo }) => {
  const navigate = useNavigate();

  const handleMoreInfo = () => {
    if (onMoreInfo) {
      onMoreInfo();
    } else {
      navigate('/orders');
    }
  };

  const getBannerText = (count) => {
    if (count === 1) {
      return 'Er is 1 bestelling die al langer dan 5 minuten onbetaald staat';
    } else {
      return `Er zijn ${count} bestellingen die al langer dan 5 minuten onbetaald staan`;
    }
  };

  if (!unpaidOrdersCount || unpaidOrdersCount === 0) {
    return null;
  }

  return (
    <BannerContainer>
      <BannerContent>
        <AlertTriangle size={24} />
        <BannerText>
          {getBannerText(unpaidOrdersCount)}
        </BannerText>
      </BannerContent>
      <BannerActions>
        <ActionButton onClick={handleMoreInfo}>
          <Info size={16} />
          Meer info
        </ActionButton>
      </BannerActions>
    </BannerContainer>
  );
};

export default RedBanner;
